import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext"; // Update this path to match your project structure
import ProfileIcon from "../ProfileIcon/ProfileIcon";
// import PunchIn from "./PunchIn";
// import NotificationCenter from "../Notifications/NotificationCenter";
// import ThemeToggle from "../ThemeToggle/ThemeToggle"; // Import the new ThemeToggle component
import Cookies from "js-cookie";
import "./Navbar.scss";
import Logo from "../../Images/Hrlabs_Logo.jpeg";
import ProfileIconImage from "../../Images/user-1.jpg";
import WhatsNew from "../WhatsNew/WhatsNew";

const Navbar = () => {
  const [menuState, setMenuState] = useState({
    isSearchExpanded: false,
    isPunchIn: false,
    openDropdown: null,
    quickAccessOpen: false,
  });

  const [logoImageSrc, setLogoImageSrc] = useState(Logo);

  // Use auth context instead of sessionStorage
  const { user, hasRole, localLogout, isAuthenticated, isLoading } = useAuth();

  // Get employee details from auth context instead of sessionStorage
  const employeeDetails = {
    employeeName: user?.employeeName || "No Name Available",
    role: user?.role || "No Role Assigned",
    authorities: user?.authorities || [],
    profileImage: user?.profileImage
      ? `data:${user.profileImageType};base64,${user.profileImage}`
      : ProfileIconImage,
  };

  // Handle company logo from auth context
  useEffect(() => {
    if (user?.logo && user?.logoType) {
      try {
        setLogoImageSrc(`data:${user.logoType};base64,${user.logo}`);
      } catch (error) {
        console.error("Error converting logo image to Base64:", error);
        setLogoImageSrc(Logo);
      }
    } else {
      setLogoImageSrc(Logo);
    }
  }, [user?.logo, user?.logoType]);

  // COMMENTED OUT: Search toggle functionality
  // const handleSearchClick = () => {
  //   setMenuState((prevState) => ({
  //     ...prevState,
  //     isSearchExpanded: !prevState.isSearchExpanded,
  //     openDropdown: prevState.openDropdown || null,
  //     quickAccessOpen: false,
  //   }));
  // };

  const navigate = useNavigate();

  // const handleNotificationNavigation = (section) => {
  //   switch (section) {
  //     case "teams":
  //       navigate("/team/manage-team-leave");
  //       break;
  //     case "ess":
  //       navigate("/ess/my-logs");
  //       break;
  //     case "compensation":
  //       navigate("/compensation-benefits/payroll");
  //       break;
  //     case "performance":
  //       navigate("/performance");
  //       break;
  //     default:
  //       navigate(`/${section}`);
  //   }
  // };

  // Use auth context logout method
  const handleLogout = async () => {
    try {
      await localLogout(); // This will handle clearing session data and redirecting
    } catch (error) {
      console.error("Logout error:", error);
      // Fallback to manual cleanup if auth context logout fails
      localStorage.clear();
      sessionStorage.clear();
      Cookies.remove("JSESSIONID");
      Cookies.remove("Refresh_Token");
      navigate("/");
      window.location.reload();
    }
  };

  // COMMENTED OUT: Punch In toggle functionality
  // const handlePunchInClick = () => {
  //   setMenuState((prevState) => ({
  //     ...prevState,
  //     isPunchIn: !prevState.isPunchIn,
  //   }));
  // };

  // COMMENTED OUT: Profile menu toggle functionality
  // const toggleProfileMenu = () => {
  //   setMenuState((prevState) => ({
  //     ...prevState,
  //     openDropdown: prevState.openDropdown === "profile" ? null : "profile",
  //     quickAccessOpen: false,
  //   }));
  // };

  // COMMENTED OUT: Quick access menu toggle functionality
  // const toggleQuickAccessMenu = () => {
  //   setMenuState((prevState) => ({
  //     ...prevState,
  //     quickAccessOpen: !prevState.quickAccessOpen,
  //     openDropdown: null,
  //   }));
  // };

  // Show loading state
  if (isLoading) {
    return (
      <nav className="navbar">
        <div className="navbar-left">
          <img src={Logo} alt="Company Logo" className="company-logo" />
        </div>
        <div className="navbar-right">
          <div className="loading-indicator">Loading...</div>
        </div>
      </nav>
    );
  }

  // Don't render navbar if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img
          src={logoImageSrc}
          alt="Company Logo"
          className="company-logo"
          onError={(e) => (e.currentTarget.src = Logo)}
        />
      </div>

      <div className="navbar-right">
        {/* <div
          className={`search-container ${
            menuState.isSearchExpanded ? "expanded" : ""
          }`}
          onMouseEnter={() =>
            setMenuState((prevState) => ({
              ...prevState,
              isSearchExpanded: true,
            }))
          }
          onMouseLeave={() =>
            setMenuState((prevState) => ({
              ...prevState,
              isSearchExpanded: false,
            }))
          }
        >
          <input
            type="text"
            placeholder="Search..."
            id="search"
            className={`search-input ${
              menuState.isSearchExpanded ? "expanded" : ""
            }`}
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <Icon
            icon="ion:search-outline"
            className="search-icon"
            // aria-label="Toggle Search"
          />
          {menuState.isSearchExpanded && filteredMenuItems.length > 0 && (
            <div className="filtered-menu">
              {filteredMenuItems.map((item) => (
                <Link
                  key={item.route}
                  to={item.route}
                  className="filtered-item"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          )}
        </div> */}

        {/* Notification Center */}
        {/* <NotificationCenter onNavigate={handleNotificationNavigation} /> */}

        {/* COMMENTED OUT: Theme Toggle Button */}
        {/* <ThemeToggle className="navbar-theme-toggle" /> */}

        {/* Quick Access Button */}
        {/* <div
          className="quick-access-container"
          onMouseEnter={() =>
            setMenuState((prevState) => ({
              ...prevState,
              quickAccessOpen: true,
            }))
          }
          onMouseLeave={() =>
            setMenuState((prevState) => ({
              ...prevState,
              quickAccessOpen: false,
            }))
          }
        >
          <button className="quick-access-button" aria-label="Quick Access">
            <Icon icon="solar:list-arrow-down-broken" />
          </button>
          {menuState.quickAccessOpen && (
            <div className="quick-access-menu">
              <Link to="/ess/apply-leave">Apply Leave</Link>
              <Link to="/ess/list-of-holidays">List of Holidays</Link>
              <Link to="/ess/fallback">Fallback</Link>

              {hasAuthority("ROLE_MANAGER") && (
                <>
                  <Link to="/team/mark-attendance">Mark Attendance</Link>
                  <Link to="/team/manage-team-leave">Manage Team Leave</Link>
                </>
              )}
            </div>
          )}
        </div> */}

        {/* COMMENTED OUT: Punch In/Out Button - Toggle functionality removed */}
        {/* <PunchIn
          className="punchin-button"
          isPunchIn={menuState.isPunchIn}
          handlePunchInClick={handlePunchInClick}
        /> */}

        <WhatsNew />

        {/* Profile Dropdown Menu */}
        <div
          className="profile-menu-container"
          onMouseEnter={() =>
            setMenuState((prevState) => ({
              ...prevState,
              openDropdown: "profile",
            }))
          }
          onMouseLeave={() =>
            setMenuState((prevState) => ({
              ...prevState,
              openDropdown: null,
            }))
          }
        >
          <button className="profile-button" aria-label="Profile Menu">
            <ProfileIcon
              size="small"
              src={employeeDetails.profileImage}
              alt="Profile"
              className="profile-avatar"
            />
            <Icon icon="mdi:chevron-down" />
          </button>
          {menuState.openDropdown === "profile" && (
            <div className="profile-menu">
              <div className="profile-info">
                <ProfileIcon
                  size="medium"
                  src={employeeDetails.profileImage}
                  alt="Profile"
                />
                <div className="profile-details">
                  <div className="profile-name">
                    {employeeDetails.employeeName}
                  </div>
                  <div className="profile-role">
                    {employeeDetails.role !== "No Role Assigned" ? (
                      <span className="role">
                        {employeeDetails.role
                          .replace("ROLE_", "")
                          .toLowerCase()
                          .split("_")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1),
                          )
                          .join(" ")}
                      </span>
                    ) : (
                      "No Role Assigned"
                    )}
                  </div>
                </div>
              </div>
              <div className="profile-options">
                <Link to="/profile">Profile</Link>
                {hasRole("ROLE_ADMIN") && (
                  <Link to="/subscriptions">My Subscriptions</Link>
                )}
                <Link to="/account-settings">Account Settings</Link>
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
